// extracted by mini-css-extract-plugin
export default {"Emojify":"bbm_a bhm_g"};